import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { pushModal, closeBudget } from 'loot-core/client/actions';

import { useLocalPref } from '../../hooks/useLocalPref';
import { SvgCheveronRight } from '../../icons/v1';
import { theme } from '../../style';
import { Tooltip } from '../tooltips';

import { Button } from './Button';
import { InitialFocus } from './InitialFocus';
import { Input } from './Input';
import { Menu } from './Menu';
import { Text } from './Text';
import { View } from './View';
import { useNavigate } from '../../hooks/useNavigate';

type RenameBudgetModalProps = {
  view?: JSX.Element;
};

export function RenameBudget({ view }: RenameBudgetModalProps) {
  const dispatch = useDispatch();

  const editBudgetNameHandler = () => {
    dispatch(pushModal('rename-budget'));
  };
  return (
    <>
      {view || (
        <View onClick={editBudgetNameHandler}>
          <Text style={{ whiteSpace: 'nowrap', overflow: 'hidden' }}>
            Rename budget
          </Text>
        </View>
      )}
    </>
  );
}

export function EditableBudgetName() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [budgetName, setBudgetNamePref] = useLocalPref('budgetName');
  const [editing, setEditing] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  function onMenuSelect(type: string) {
    setMenuOpen(false);

    switch (type) {
      case 'close':
        dispatch(closeBudget());
        navigate('/');
        break;
      default:
    }
  }

  const items: any = [
    { name: 'rename', text: <RenameBudget /> },
    { name: 'close', text: 'Close file' },
  ];

  if (editing) {
    return (
      <InitialFocus>
        <Input
          style={{
            width: 160,
            fontSize: 16,
            fontWeight: 500,
          }}
          defaultValue={budgetName}
          onEnter={async e => {
            const inputEl = e.target as HTMLInputElement;
            const newBudgetName = inputEl.value;
            if (newBudgetName.trim() !== '') {
              setBudgetNamePref(newBudgetName);
              setEditing(false);
            }
          }}
          onBlur={() => setEditing(false)}
        />
      </InitialFocus>
    );
  } else {
    return (
      <Button
        type="bare"
        color={theme.buttonNormalBorder}
        style={{
          fontSize: 16,
          fontWeight: 500,
          marginLeft: -5,
          flex: '0 auto',
        }}
        onClick={() => setMenuOpen(true)}
      >
        <Text
          style={{
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
          }}
        >
          {budgetName}
        </Text>
        <SvgCheveronRight width={10} height={10} style={{ marginLeft: 5 }} />
        {menuOpen && (
          <Tooltip
            position="top-right"
            style={{ padding: 0 }}
            onClose={() => setMenuOpen(false)}
          >
            <Menu onMenuSelect={onMenuSelect} items={items} />
          </Tooltip>
        )}
      </Button>
    );
  }
}
